import React from "react";
import HeaderCell from "./HeaderCell";
import { IFilteringState, ISortState } from "../utils/types";
import { createUniqueKey } from "../../../utils";

export interface IHeaderColumn {
    key?: string;
    title?: string;
    width?: string | number;
    minWidth?: string | number;
    maxWidth?: string | number;
    hidden?: boolean;
    sortable?: boolean;
    className?: string;
}

export interface IHeaderControls {
    selectControlsLabel?: {
        selectAll?: string;
        reset?: string;
    };
    sortByLabel?: string;
}

export interface IHeaderProps {
    columns?: IHeaderColumn[];
    sorting?: ISortState;
    filtering?: IFilteringState;
    resetColumns?: () => void;
    changeColumns?: (...args: any[]) => void;
    changeSorting?: (...args: any[]) => void;
    changeFiltering?: (...args: any[]) => void;
    headerControls: IHeaderControls;
}

function Header(props: IHeaderProps) {
    const {
        columns = [],
        sorting,
        filtering,
        resetColumns,
        changeColumns = () => {},
        changeSorting = () => {},
        headerControls,
        changeFiltering = () => {},
    } = props;
    const visibleColumns = columns.filter(({ hidden }) => !hidden);

    return (
        <thead>
            <tr role="row">
                {visibleColumns.map((column, index) => (
                    <HeaderCell
                        column={column}
                        columns={columns}
                        sorting={sorting}
                        filtering={filtering}
                        resetColumns={resetColumns}
                        changeColumns={changeColumns}
                        changeSorting={changeSorting}
                        headerControls={headerControls}
                        changeFiltering={changeFiltering}
                        key={createUniqueKey(index, column.key)}
                        isFirst={index === 0}
                        isLast={index === visibleColumns.length - 1}
                    />
                ))}
            </tr>
        </thead>
    );
}

export default Header;
